import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import HookAlpha from "../pages/hook-alpha/page";
import HookBeta from "../pages/hook-beta/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HookAlpha />,
  },
  {
    path: "/hook-alpha",
    element: <HookAlpha />,
  },
  {
    path: "/hook-beta",
    element: <HookBeta />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
